import { MutableRefObject, useRef } from 'react';

import { PaymentsAuthAPIServiceTypes } from '../../services/PaymentsAuthServices/APIService';
import { PaymentsAuthAPIService } from '../../services/PaymentsAuthServices/APIService/index.api';
import { networkCallWithApisauce } from '../../utils/AuthAPIUtils';

const usePaymentsAuthRefreshTokenAPIService = () => {
  const PaymentsAuthRefreshTokenAPIRef: MutableRefObject<PaymentsAuthAPIServiceTypes | null> =
    useRef(null);

  if (PaymentsAuthRefreshTokenAPIRef.current === null) {
    PaymentsAuthRefreshTokenAPIRef.current = new PaymentsAuthAPIService(
      networkCallWithApisauce
    );
  }

  return {
    paymentsAuthRefreshTokenAPIService: PaymentsAuthRefreshTokenAPIRef.current
  };
};

export { usePaymentsAuthRefreshTokenAPIService };
